export default __webpack_public_path__ + "static/media/prof-mobile.f84517f9.svg";